// Dashboard-specific SWR hooks. Date gates each fetch so we don't fire
// the endpoint before the parent has resolved the selected month.
import useSwr from "swr"
import { DashboardApi } from "../../apis"

export interface TopProduct {
  name: string
  count: number
}

export function useTopProducts(date: string | null) {
  const { data } = useSwr<TopProduct[]>(
    date ? `swr.dashboard.top-products.${date}` : null,
    async () => DashboardApi.topProducts({ date: date! }),
    { revalidateOnFocus: false },
  )
  return data ?? []
}

export interface DeliveryStats {
  deliveryRate: number
  avgDeliveryDays: number | null
}

export function useDeliveryStats(date: string | null): DeliveryStats {
  const { data } = useSwr(
    date ? `swr.dashboard.delivery-stats.${date}` : null,
    async () => DashboardApi.deliveryStats({ date: date! }),
    { revalidateOnFocus: false },
  )
  // /ord/dashboard/delivery-stats answers with completionRate /
  // averageDeliveryDays. Reading deliveryRate / avgDeliveryDays off it always
  // missed, so the card was pinned at 0% and "- хоног" for every user.
  return {
    deliveryRate: data?.completionRate ?? 0,
    avgDeliveryDays: data?.averageDeliveryDays ?? null,
  }
}
